import FingerprintJS from '@fingerprintjs/fingerprintjs';

export const getFingerprintJS = function() {
  return new Promise((resolve, reject) => {
      FingerprintJS.load().then(fp => {
        // The FingerprintJS agent is ready.
        // Get a visitor identifier when you'd like to.
        fp.get().then(result => {
            // This is the visitor identifier:
            const visitorId = result.visitorId;
            // console.log(visitorId);
            resolve(visitorId)
        });
      }).catch(() => {
        resolve('');
      });
  })
}